export const appVersion = 'v1.0.2';